import listActions from 'src/modules/voting/list/votingListActions';
import VotingService from 'src/modules/voting/votingService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'VOTING_DESTROY';

const votingDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: votingDestroyActions.DESTROY_STARTED,
      });

      await VotingService.destroyAll([id]);

      dispatch({
        type: votingDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.voting.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/voting');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: votingDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: votingDestroyActions.DESTROY_ALL_STARTED,
      });

      await VotingService.destroyAll(ids);

      dispatch({
        type: votingDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.voting.destroyAll.success'),
      );

      getHistory().push('/voting');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: votingDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default votingDestroyActions;
